export const getUserData = state => state?.user?.userData;
